export default __webpack_public_path__ + "static/media/404.0d158f96.gif";